<template>
    <div class="item-progress">
        <p v-if="title" class="progress-title">{{ title }}</p>
        <div class="progress-details">
            <div class="progress-value">{{ value }}{{ suffix }} <span class="progress-label">{{ label }}</span></div>
            <div class="progress-hint nowrap" v-if="remaining !== ''">
              <span>{{ (remainingLabel ? remainingLabel : 'Pozostało') }}: </span>
              <strong>{{ remaining }} pkt.</strong>
            </div>
        </div>
        <progress-bar v-if="bar" :size="size" :bar-color="color" :val="(value >= 0) ? value : 0"></progress-bar>
    </div>
</template>

<script>
    import ProgressBar from 'vue-simple-progress'

    export default {
        name: 'ItemProgress',
        props: ['bar','title','value','suffix','label','remaining','remainingLabel','size','color'],
        components: { ProgressBar }
    }
</script>
